import { normalizeId } from "./normalize";

export const getAllContainerIdsFromTerminalCalls = (terminalCalls: any[] = []): string[] => {
    const containerIds = new Set<string>();

    if (terminalCalls?.length === 0) {
        return Array.from(containerIds);
    }
  
    terminalCalls.forEach((call) => {
      const collectIds = (source: any[]) => {
        source?.forEach((c) => {
          const id = normalizeId(c);
          if (id) containerIds.add(id);
        });
      };
  
      const collectFromContainerPositions = (state: any) => {
        const positions = state?.container_positions || [];
        positions.forEach((entry: any[]) => {
          if (Array.isArray(entry) && typeof entry[0] === 'number') {
            containerIds.add(String(entry[0]));
          }
        });
      };
  
      collectIds(call.loadingContainers || []);
      collectIds(call.unloadingContainers || []);
      collectFromContainerPositions(call.arrivalState);
      collectFromContainerPositions(call.departureState);
      collectFromContainerPositions(call.bargearrivalState);
      collectFromContainerPositions(call.bargedepartureState);
    });
  
    return Array.from(containerIds);
  };